module.exports = __webpack_public_path__ + "static/media/logo.0227c960.png";